import { useLoaderData, useNavigate } from "react-router-dom";
import schoolsAPI from "../../services/schools";
import MeaPage from "../../components/MeaPage";

import { PERMISSION_SCHOOL_DETAILS, PERMISSION_SCHOOL_MEMBERS, PERMISSION_SCHOOL_POLICIES, PERMISSION_SCHOOL_TRAININGS, PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS, PERMISSION_TRAINING_STUDENT_OBSERVATIONS } from "../../permissions";
import { useAuthContext } from "../../hooks/useAuthContext";

export async function loader({ params }) {
  const result = await schoolsAPI.GetOneSchool(params.schoolId);
  return { school: result?.data };
}

export function SchoolHome() {
  const { school } = useLoaderData();
  const { hasPermission, currentMembership } = useAuthContext();
  const navigate = useNavigate();

  return (
    <>
      <MeaPage
        showBackButton={false}
        header={
          <div>
            <div
              style={{
                height: "180px",
                background:
                  'url("/images/school-empty-cover.jpeg") no-repeat',
                backgroundSize: "cover",
              }}
            ></div>
            <div className="px-4 py-0 md:px-6 lg:px-8 ">
              <div
                className="flex flex-column lg:flex-row lg:align-items-center lg:justify-content-between relative"
                style={{
                  marginTop: "-2rem",
                  top: "-50px",
                  marginBottom: "-70px",
                }}
              >
                <div>
                  <div
                    style={{
                      width: "140px",
                      height: "140px",
                      borderRadius: "10px",
                    }}
                    className="mb-3 surface-card shadow-2 flex align-items-center justify-content-center"
                  >
                    <img
                      src={school?.avatar
                        ? school?.avatar + "?" + school?.updated_at
                        : "/images/school-empty-logo.svg"}
                      width="90%"
                    />
                  </div>
                  <div className="text-900 text-3xl font-medium mb-1">
                    {school?.name}
                  </div>
                  <div className="text-600 font-medium mb-3">
                    <span className="bg-teal-50 text-teal-700 px-3 py-1 border-round text-sm font-semibold">
                      Espace Administration
                    </span>
                  </div>
                  {/* <p className="mt-0 mb-0 text-700 text-xl">
                    {school?.presentation}
                  </p>
                  <div className="text-600 mb-3 font-medium">
                    <span>{school?.address}</span>
                  </div> */}
                </div>
                <div className="mt-3 lg:mt-0">
                </div>
              </div>
            </div>
          </div>
        }
      >
        <div className="grid grid-nogutter pt-4">
          {hasPermission(PERMISSION_SCHOOL_TRAININGS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => navigate("/school/" + school?.id + "/admin/trainings")}
            >
              <div className="flex">
                <img src="/images/icons/trainings.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="1" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Formations</span>
                  <span className="text-600 font-medium mb-2">Gérer les formations de l'école</span>
                </div>
              </div>
            </div>
          </div>}
          
          {hasPermission(PERMISSION_SCHOOL_TRAININGS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => {
                const lastVisited = currentMembership?.preferences?.last_visited_training;
                if (lastVisited) {
                  navigate("/school/" + school?.id + "/admin/registrations/" + lastVisited + "/candidates");
                } else {
                  navigate("/school/" + school?.id + "/admin/registrations?target=candidates");
                }
              }}
            >
              <div className="flex">
                <img src="/images/icons/registration.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="1" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Inscriptions</span>
                  <span className="text-600 font-medium mb-2">Gérer les inscriptions des élèves</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_SCHOOL_TRAININGS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => {
                const lastVisited = currentMembership?.preferences?.last_visited_training;
                if (lastVisited) {
                  navigate("/school/" + school?.id + "/admin/registrations/" + lastVisited + "/payments");
                } else {
                  navigate("/school/" + school?.id + "/admin/registrations?target=payments");
                }
              }}
            >
              <div className="flex">
                <img src="/images/icons/atm-card.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="5" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Paiements</span>
                  <span className="text-600 font-medium mb-2">Accéder aux paiements des inscriptions</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_SCHOOL_TRAININGS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => navigate("/school/" + school?.id + "/admin/registrations?target=campaigns")}
            >
              <div className="flex">
                <img src="/images/icons/mail.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="6" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Campagnes d'e-mails</span>
                  <span className="text-600 font-medium mb-2">Accéder aux campagnes e-mails des inscriptions</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_SCHOOL_TRAININGS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => {
                const lastVisited = currentMembership?.preferences?.last_visited_training;
                if (lastVisited) {
                  navigate("/school/" + school?.id + "/admin/avis-passage/" + lastVisited);
                } else {
                  navigate("/school/" + school?.id + "/admin/avis-passage");
                }
              }}
            >
              <div className="flex">
                <img src="/images/icons/moving.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="avis-passage" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Avis de passage</span>
                  <span className="text-600 font-medium mb-2">Renseigner les avis de passage des classes</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_SCHOOL_TRAININGS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => navigate("/school/" + school?.id + "/admin/registrations?target=settings")}
            >
              <div className="flex">
                <img src="/images/icons/smartphone.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="7" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Gestion de l'espace famille</span>
                  <span className="text-600 font-medium mb-2">Accéder aux paramètres de l'espace famille</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => {
                const lastVisited = currentMembership?.preferences?.last_visited_training;
                if (lastVisited) {
                  navigate("/school/" + school?.id + "/admin/slot-change-requests/" + lastVisited);
                } else {
                  navigate("/school/" + school?.id + "/admin/slot-change-requests");
                }
              }}
            >
              <div className="flex">
                <img src="/images/icons/exchange.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="slot-change" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Changements de créneau</span>
                  <span className="text-600 font-medium mb-2">Consulter et traiter les demandes de changement de créneau</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_TRAINING_STUDENT_OBSERVATIONS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => {
                const lastVisited = currentMembership?.preferences?.last_visited_training;
                navigate("/school/" + school?.id + "/admin/student-observations" + (lastVisited ? "/" + lastVisited : ""));
              }}
            >
              <div className="flex">
                <img src="/images/icons/observations.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="student-observations" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Suivi des observations</span>
                  <span className="text-600 font-medium mb-2">Consulter les observations des élèves de la formation en cours</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_SCHOOL_TRAININGS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => navigate("/school/" + school?.id + "/admin/emails")}
            >
              <div className="flex">
                <img src="/images/icons/email.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="emails" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Emails</span>
                  <span className="text-600 font-medium mb-2">Consulter les derniers emails envoyés</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_SCHOOL_MEMBERS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => navigate("/school/" + school?.id + "/admin/members")}
            >
              <div className="flex">
                <img src="/images/icons/members.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="2" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Membres</span>
                  <span className="text-600 font-medium mb-2">Gérer les membres de l'école</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_SCHOOL_POLICIES.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={(e) => navigate("/school/" + school?.id + "/permissions")}
            >
              <div className="flex">
                <img src="/images/icons/permissions.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="3" />
              <div className="flex flex-column align-items-start">
                <span className="text-lg text-900 font-medium mb-1">Permissions</span>
                <span className="text-600 font-medium mb-2">Gestion de rôles et permissions</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_SCHOOL_DETAILS.GET) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => navigate("/school/" + school?.id + "/about")}
            >
              <div className="flex">
                <img src="/images/icons/school.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="4" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">L'école</span>
                  <span className="text-600 font-medium mb-2">Informations sur l'école</span>
                </div>
              </div>
            </div>
          </div>}
        </div>
      </MeaPage>
    </>
  );
}
